/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React, { CSSProperties } from 'react';
import './styles.scss';

const LoadingAnimation = (props: { className?: string, style?: CSSProperties }) => {

  const { style, className = ''} = props;

  return <>
    <div className={`mosaic-loader ${className}`} style={style}>
      <div className='cell s-0' ></div>
      <div className='cell s-1' ></div>
      <div className='cell s-2' ></div>
      <div className='cell s-3' ></div>
      <div className='cell s-4' ></div>
      <div className='cell s-5' ></div>
      <div className='cell s-6' ></div>
      <div className='cell s-7' ></div>
      <div className='cell s-8' ></div>
      <div className='cell s-9' ></div>
      <div className='cell s-10' ></div>
      <div className='cell s-11' ></div>
      <div className='cell s-12' ></div>
      <div className='cell s-13' ></div>
      <div className='cell s-14' ></div>
      <div className='cell s-15' ></div>
      <div className='cell s-16' ></div>
    </div>
  </>
}


export default LoadingAnimation;


